import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, GridItem, Heading, VStack, Text,
} from '@chakra-ui/react';

const getBorderColor = (idx) => {
  if (idx === 0) return 'yellow.400';
  if (idx === 1) return 'gray.400';
  if (idx === 2) return 'orange.400';
  return 'gray.200';
};

const getRankDisplay = (idx) => {
  if (idx === 0) return '🥇';
  if (idx === 1) return '🥈';
  if (idx === 2) return '🥉';
  return `#${idx + 1}`;
};

export const SpiritPointsLeaderboard = ({ teams }) => {
  if (!teams || teams.length === 0) {
    return null;
  }

  const validTeams = teams.filter((team) => team.totalSpiritPoints >= 0);

  if (validTeams.length === 0) {
    return null;
  }

  return (
    <>
      <GridItem gridArea="1 / 1 / 2 / 2">
        <Heading size="md">Spirit Points Leaderboard</Heading>
      </GridItem>
      <GridItem gridArea="2 / 1 / 3 / 2">
        <VStack spacing={2} paddingY={2}>
          {validTeams.map((team, idx) => (
            <Box
              key={team.id}
              padding={3}
              width="100%"
              borderWidth={1}
              borderLeftWidth={4}
              borderLeftColor={getBorderColor(idx)}
              borderRadius="md"
              bg={idx === 0 ? 'yellow.50' : 'white'}
            >
              <Text fontSize="md" fontWeight="bold">
                {getRankDisplay(idx)}
                {' '}
                {team.school.name}
              </Text>
              <Text fontSize="sm" color="gray.600" fontWeight="semibold">
                {team.totalSpiritPoints.toLocaleString()}
                {' '}
                points
              </Text>
            </Box>
          ))}
        </VStack>
      </GridItem>
    </>
  );
};

SpiritPointsLeaderboard.propTypes = {
  teams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      totalSpiritPoints: PropTypes.number.isRequired,
      school: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
    }),
  ),
};

SpiritPointsLeaderboard.defaultProps = {
  teams: [],
};
